var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, observable, makeObservable } from "mobx";
import { enableStaticRendering } from "mobx-react-lite";
import { SettingsRepository } from "@repo/fetch-repository/settings";
enableStaticRendering(typeof window === "undefined");
export class SettingStore {
    constructor() {
        this.settingStore = null;
        makeObservable(this, {
            settingStore: observable,
            setSettingStore: action,
            hydrate: action,
        });
    }
    fetchSettingStore(locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const settingsRepository = new SettingsRepository(locale);
            const settingStore = yield settingsRepository.getMany();
            if (!settingStore.succeeded) {
                throw new Error("Setting store not found");
            }
            this.setSettingStore(settingStore.data);
        });
    }
    getWithKey(key) {
        var _a;
        if (!this.settingStore)
            return null;
        return ((_a = this.settingStore.find((item) => item.key === key)) === null || _a === void 0 ? void 0 : _a.value) || null;
    }
    setSettingStore(settingStore) {
        this.settingStore = settingStore;
    }
    hydrate(data) {
        if (!data)
            return;
        this.settingStore = data;
    }
}
